import React from 'react';
import { Icon } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import classNames from 'classnames';

const baseString = 'layers-request-error';

const classString = classNames({
  [baseString]: true,
  'no-data': true
});

const ZoneGenerationErrorRequestingLayers = () => {
  return (
    <section className={classString} data-test-id={baseString}>
      <Icon glyph={Icon.set.WARNING_CIRCLE} />
      <p>{getMessage('text__request-zone-generation-layers-error')}</p>
    </section>
  );
};

export default ZoneGenerationErrorRequestingLayers;
